import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { useExperiments } from '@wix/fe-essentials-standalone';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import { enableInternalMarketplaceSpec } from '@utils/constants';
import MarketplaceHeader from './MarketplaceHeader';
import { PAGE_NAMES } from '@utils/partnerProfileUtils';
import AgencyProfileHeader from '@components/AgencyProfileHeader';

interface Props {
  onClick?: () => void;
  sessionId?: string;
  pageName?: string;
}

const Header: FC<Props> = ({ onClick, pageName }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { experiments } = useExperiments({ readOnly: true });
  const { userDetails, userProfileImage, services, host, loading } =
    useHeaderContext();

  const isInternal = experiments.enabled(enableInternalMarketplaceSpec);

  const headerData = {
    services,
    keys: {
      services: t('marketplace-header-link-services'),
      studioTemplates: t('marketplace-header-link-studio-templates'),
      sellInMarketplace: t('marketplace-header-link-sell-in-marketplace'),
      offerServices: t('marketplace-header-link-offer-services'),
      offerServicesUrl: t('marketplace-header-link-offer-services-url'),
      sellStudioTemplates: t('marketplace-header-link-sell-studio-templates'),
      sellStudioTemplatesUrl: t(
        'marketplace-header-link-sell-studio-templates-url',
      ),
      join: t('marketplace-header-link-join'),
      hire: t('marketplace-header-link-hire'),
      btnLogin: t('marketplace-header-btn-login'),
      btnLogout: t('marketplace-header-btn-logout'),
      myProjects: t('marketplace-header-link-my-projects'),
      contactSupport: t('marketplace-header-link-contact-support'),
      accountSettings: t('marketplace-header-link-account-settings'),
      wix: t('marketplace-header-link-wix'),
      wixSites: t('marketplace-header-link-wix-sites'),
      mobileTitle: t('marketplace-header-mobile-title'),
      mobileServiceMenuTitle: t('marketplace-header-mobile-browse-services'),
      mobileLanguageSelectionTitle: t(
        'marketplace-header-mobile-language-selection-title',
      ),
    },
    userData: userDetails,
    userProfileImage,
  };

  if (
    pageName === PAGE_NAMES.PROFILE_PAGE ||
    pageName === PAGE_NAMES.NOT_FOUND_PAGE
  ) {
    return (
      <AgencyProfileHeader
        isLoading={loading}
        onClick={onClick}
        headerData={headerData}
        isInternal={isInternal}
        language={language}
        pageName={pageName}
        origin={host}
      />
    );
  }

  return (
    <MarketplaceHeader
      loading={loading}
      onClick={onClick}
      headerData={headerData}
      isInternal={isInternal}
      language={language}
      pageName={pageName}
      origin={host}
    />
  );
};

export default Header;
